import { TypePolicy } from '@apollo/client';

export const applicationUserTypePolicy: TypePolicy = {
  fields: {
    applications: {
      merge( _existing, incoming ) {
        return incoming;
      },
    },
  },
};
